import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        Cargando...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.rol)) {
    // Redirigir al dashboard según el rol del usuario
    if (user.rol === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    } else if (user.rol === 'entrenador') {
      return <Navigate to="/entrenador/dashboard" replace />;
    } else {
      return <Navigate to="/cliente/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
